<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}个{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" type="danger" :disabled="multiple" v-preventReClick @click="handleDelete">
            批量删除
          </el-button>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span class="reset" v-preventReClick @click="reset">重置</span>
        </div>
      </div>
      <div style="margin-bottom: 10px">
        <el-tabs v-model="query.approveState" @tab-click="tabClick" stretch>
          <el-tab-pane v-for="item in SupplierOrderStateArray" :key="item.id" :name="item.id + ''">
            <template slot="label">
              <!--  -->
              <el-badge :value="item.count" :max="99" class="item">
                <span style="margin: 0 10px"> {{ item.name }} </span>
              </el-badge>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column type="selection" :reserve-selection="true" fixed align="center" width="55">
        </el-table-column>
        <!-- <el-table-column prop="name" label="供应商名称" width="190">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span><br />
            <span>{{ scope.row.no }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="no" label="供应商编码" width="180">
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row,0)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="供应商名称" width="190"></el-table-column>
        <el-table-column prop="creditCode" label="组织机构代码" width="180"></el-table-column>
        <!-- <el-table-column prop="code" label="所在省/市" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.countryName }}</span>
          <span v-if="scope.row.provinceName">{{ "/" + scope.row.provinceName }}</span>
          <span v-if="scope.row.cityName">{{ "/" + scope.row.cityName }}</span>
        </template>
      </el-table-column> -->
        <el-table-column prop="contactor" label="联系人">
          <template slot-scope="scope">
            <span>{{ scope.row.contactor?scope.row.contactor:'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="联系电话" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.phone?scope.row.phone:'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="stateName" label="状态" width="80">
          <template slot-scope="scope">
            <span :class="{
                enable: scope.row.state == 1,
                forbidden: scope.row.state == 0,
              }">{{ scope.row.stateName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.remark?scope.row.remark:'-' }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="operation" fixed="right" width="240" label="操作">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row, 0)" class="color-blue">查看</el-button> -->
            <el-button v-if="query.approveState == 1" type="text" v-preventReClick @click="approvalEvt(scope.row, 1)" class="color-blue">通过</el-button>
            <el-button v-if="query.approveState == 1" type="text" v-preventReClick @click="approvalEvt(scope.row, 2)" class="color-blue">拒绝</el-button>

            <!-- v-if="tableAcl.indexOf('Edit') != -1" -->
            <el-button v-if="query.approveState == 2" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <!-- <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" class="margin-left20 color-blue" v-preventReClick @click="handleDelete(scope.row)">删除</el-button> -->
            <el-button v-if="query.approveState == 2" type="text" v-preventReClick @click="approvalEvt(scope.row, 3)" class="color-blue">禁用</el-button>
            <el-button type="text" v-if="query.approveState == 2" class="margin-left20 color-blue" v-preventReClick @click="copySupplierProductDialog(scope.row)">复制</el-button>
            <el-button type="text" v-if="query.approveState == 2" class="margin-left20 color-blue" v-preventReClick @click="showPushDataDialog(scope.row)">推送</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>

    <el-dialog title="推送供应商产品" :visible.sync="pushDataDialogVisible" width="60%">
      <el-form ref="pushForm" v-loading="loading" :model="pushForm" label-width="110px">
        <el-row>
          <el-col :span="12">
            <span>推送此供应商的供应商产品到对应的供应商系统</span>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="range" label="推送范围">
              <el-radio-group v-model="pushForm.range">
                <el-radio :label="0">所有产品</el-radio>
                <el-radio :label="1">未推送过的产品</el-radio>
                <el-radio :label="2">指定产品</el-radio>
                <el-radio :label="3">按时间筛选</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="pushForm.range == 2">
          <el-col :span="24">
            <el-form-item prop="supplierProductIds" label="供应商产品">
              <el-select v-model="pushForm.supplierProductIds" multiple placeholder="请选择供应商产品" filterable :filter-method="getSupplierProductList" style="width: 100%">
                <el-option v-for="item in STATIC_SupplierProducts" :key="item.id" :label="item.no + ' ' + item.productName + ' ' + item.specName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="pushForm.range == 3">
          <el-col :span="24">
            <el-form-item prop="dateRange" label="创建时间范围">
              <el-date-picker v-model="pushForm.dateRange" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="创建开始日期" end-placeholder="创建结束日期" value-format="yyyy-MM-dd" @input="dateRangeChange" />
              <!-- <el-select v-model="pushForm.dateRange" multiple placeholder="请选择时间范围" filterable :filter-method="getSupplierProductList">
                <el-option v-for="item in STATIC_SupplierProducts" :key="item.id" :label="item.no + ' ' + item.productName" :value="item.id"></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="pushData">确 定</el-button>
        <el-button @click="pushDataDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="复制供应商产品" :visible.sync="copySupplierProductDialogVisible" @close="closeEvt" width="40%">
      <el-form ref="pushForm" v-loading="loading" v-model="copyForm" label-width="120px">
        <el-row>
          <el-col :span="24" style="color: #e6a23c; line-height: 57px">
            <span>此操作将批量复制所选择的供应商产品，并赋予新供应商名称，生成该供应商的供应商产品。</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="oldSupplierId" label="供应商名称">
              <el-input disabled v-model="copyForm.oldSupplierName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="supplierName" label="新供应商名称">
              <el-select v-model="copyForm.supplierId" placeholder="请选择" filterable :filter-method="(value) => getSuppliers1(value, 1)" @change="supplierChange" style="width: 100%">
                <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="isCopyDisabledSP" label="是否复制禁用产品" label-width="150px">
              <el-radio-group v-model="copyForm.isCopyDisabledSP">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="isDisabledOldSP" label="是否禁用旧供应商产品" label-width="150px">
              <el-radio-group v-model="copyForm.isDisabledOldSP">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="copyData">确 定</el-button>
        <el-button @click="closeEvt">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetSuppliers,
  RemoveSuppliers,
  PushDataToDrm,
  CountMySupplierStateNum,
  UpdateMySupplierApproveStateById,
  CopySupplierProductsBySupplier,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin";
import GetSpdDataMixin from "@/mixin/getData-spd-mixin";

export default {
  components: {},
  mixins: [GetDataMixin, GetSpdDataMixin],
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        sourceType:0
      },
      // 新增和编辑都可写
      editMode: false,
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // // 新增启用开关
      // iso: true,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      // 列表多选
      multiple: true,
      pushDataDialogVisible: false,
      copySupplierProductDialogVisible: false,
      pushForm: {},
      copyForm: {},
      loading: false,
      SupplierOrderStateArray: [{
        id: 0,
        count: 0,
        name: "全部",
      },
      {
        id: 1,
        count: 0,
        name: "待审核",
      },
      {
        id: 2,
        count: 0,
        name: "已审核通过",
      },
      {
        id: 3,
        count: 0,
        name: "已审核拒绝",
      },
      {
        id: 4,
        count: 0,
        name: "已解除关系",
      },
      ],
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
      // this.ids = val;
    },
    // 获取列表
    getData () {
      GetSuppliers(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;
        this.getCountMySupplierStateNum();
      });
    },
    // 查看信息
    handleInfo (row, num) {
      // this.$router.push("/supplier-edit?formMode=0&id=" + row.id);
      this.routePushWithParams("/supplier-edit", this.query, {
        formMode: num,
        id: row.id,
      });
    },
    // 新建
    handleAdd () {
      // this.editMode = true
      // this.open = true
      // this.title = "新建"
      // this.resetForm()

      // this.$router.push("/supplier-edit?formMode=1");
      this.routePushWithParams("/supplier-edit", this.query, {
        formMode: 1,
      });
    },
    // 编辑
    handleUpdate (row) {
 
      this.routePushWithParams("/supplier-edit", this.query, {
        formMode: 2,
        id: row.id,
      });
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },
    // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("确认要删除吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemoveSuppliers({
            ids,
          });
        })
        .then(() => {
          this.$my_message(`删除成功`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query.keyWord = "";
      this.$set(this.query, "pageIndex", 1);
      this.$set(this.query, "pageSize", 10);
      this.query.sourceType = 0;
      this.ids = [];
      this.multipleSelection = [];
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },

    showPushDataDialog (row) {
      this.pushDataDialogVisible = true;
      this.pushForm = {
        range: 0,
        supplierProductIds: [],
        supplierId: row.id,
      };

      this.getSupplierProductList("");
    },
    closeEvt () {
      this.copySupplierProductDialogVisible = false;
      this.copyForm.supplierId = "";
    },
    copySupplierProductDialog (row) {
      this.copySupplierProductDialogVisible = true;
      this.copyForm = {
        isDisabledOldSP: 0,
        isCopyDisabledSP: 0,
        oldSupplierId: row.id,
        oldSupplierName: row.name,
      };
    },
    copyData () {
      // this.loading = true;
      CopySupplierProductsBySupplier(this.copyForm).then((res) => {
        if (!res.successful) {
          return;
        }
        this.$message.success(`复制成功`);
        // this.loading = false;
        this.copySupplierProductDialogVisible = false;
      });
    },
    supplierChange (val) {
      this.copyForm.supplierId = val;
      this.copyForm.supplierName = this.STATIC_Suppliers.filter(
        (item) => item.id == val
      )[0].name;
    },
    getSupplierProductList (keyWord) {
      this.getSupplierProducts({
        keyWord,
        supplierId: this.pushForm.supplierId,
      });
    },
    pushData () {
      this.loading = true;
      PushDataToDrm(this.pushForm).then((res) => {
        if (!res.successful) {
          return;
        }
        this.$message.success(`提交成功`);
        this.loading = false;
        this.pushDataDialogVisible = false;
      });
    },
    dateRangeChange (val) {
      this.$nextTick(() => {
        if (val == null) {
          this.pushForm.startDate = "";
          this.pushForm.endDate = "";
        } else {
          this.pushForm.startDate = val[0];
          this.pushForm.endDate = val[1];
        }
      });
    },
    tabClick (val) {
      this.query.approveState = val.index;
      this.getData();
    },
    //
    getCountMySupplierStateNum () {
      CountMySupplierStateNum({
        keyWord: this.query.keyWord,
        sourceType:0
      }).then((res) => {
        if (res.returnData) {
          this.SupplierOrderStateArray[0].count = res.returnData.all;
          this.SupplierOrderStateArray[1].count = res.returnData.passing;
          this.SupplierOrderStateArray[2].count = res.returnData.pass;
          this.SupplierOrderStateArray[3].count = res.returnData.refused;
          this.SupplierOrderStateArray[4].count = res.returnData.remove;
        }
        this.$forceUpdate();
      });
    },
    // 审批我的供应商
    approvalEvt (row, num) {
      let data = {
        id: row.id,
        state: num,
      };
      if (num == 2) {
        this.$prompt("请输入拒绝理由", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(({
            value
          }) => {
            data.refuse = value;
            UpdateMySupplierApproveStateById(data).then((res) => {
              this.getData();
            });
          })
          .catch(() => {
            return;
          });
        return;
      }
      if (num == 3) {
        this.$confirm("确定解除与该供应商的合作关系吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            UpdateMySupplierApproveStateById(data).then((res) => {
              this.getData();
            });
          })
          .catch(() => {
            return;
          });
        return;
      }
      UpdateMySupplierApproveStateById(data).then((res) => {
        this.getData();
      });
    },
  },
  created () {
    // 分页组件默认值需要早created
    if (this.$route.params) {
      this.query = this.$route.params;
    }
    this.query.sourceType = 0;
    this.getCountMySupplierStateNum();
    this.getSuppliers1("", 1);
  },
  mounted () {
    // 查询组件默认值需要在mounted
    // if (this.$route.params) {
    //   this.$refs["selectFilter"].query = this.query
    // }
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.el-tabs {
  width: 800px;
  // margin-bottom: 10px;
}

/deep/.el-badge__content.is-fixed {
  top: 10px !important;
  right: 16px !important;
}

/deep/.el-tabs--top .el-tabs__item.is-top:last-child,
.el-tabs--top .el-tabs__item.is-bottom:last-child,
.el-tabs--bottom .el-tabs__item.is-top:last-child,
.el-tabs--bottom .el-tabs__item.is-bottom:last-child {
  padding-right: 20px !important;
}
</style>
